import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SharedService } from '../../services/sharedservices.service';
import * as CryptoJS from 'crypto-js';
import { config } from 'config/config';

import {of} from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';

import { IdleTimeoutService } from '../../services/idle-timeout.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private sharedservice: SharedService, private idleTimeoutService: IdleTimeoutService) { }

    canActivate() {
        if ((location.protocol !== 'https:')) {
            location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
            return false;
        }

        if (this.sharedservice.checkCredentials()) {
            // const conversionOutput = CryptoJS.AES.decrypt(localStorage.getItem("mca_d"), config.key).toString(CryptoJS.enc.Utf8);

            // this.sharedservice.session = safeParse<any>(conversionOutput);

          this.idleTimeoutService.startWatching(() => this.sharedservice.logout());
          return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}

/*
function safeParse<T = any>(raw: string | null): T | null {
  if (raw == null) {
    return null;
  }
  const s = raw.trim();
  if (!s || s === 'null' || s === 'undefined') {
    return null;
  }
  try { return JSON.parse(s) as T; } catch (e) { return null; }
}
*/



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/guard/guard.ts